import React from "react";
import {useSelector} from "react-redux";
import {Button, Link, Tooltip} from "@material-ui/core";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";
import {useActions} from "../../actions";
import * as Aws from "../../actions/aws";
import {RootState} from "../../reducers";
import {PreviewFileDialog} from "../../pages/client/Enrollment/EnrollmentHome/basicInfo/ViewAndDelete";
import pdfIcon from "../../styles/images/pdfIcon.png";
import {downloadDocument, isDebug, isFunc} from "../../utils/commonUtils";


type FileType = {
    name: string,
    viewTitle: string
}
type Props<T> = {
    file: T
    directory?: string // if  directory will pass through the props then we use it as the s3 bucket location by default it will search in the current login user enrollment directory
    onDelete?: any,
    OnView?: (props: T) => void
}
const PreviewFiles: <T extends FileType>(p: Props<T>) => React.ReactElement<Props<T>> = (props) => {
    let {directory, onDelete, file, OnView} = props;
    const [secureFilePath, setSecureFilePath] = React.useState();
    const awsActions = useActions(Aws);
    const [fileExt, setFileExt] = React.useState();
    const [popUpImage, setPopUpImage] = React.useState(false);
    const {user, user: {client}}:any = useSelector((state: RootState) => state.auth);
    const enrollment = client && client.clientPolicies && client.clientPolicies[0].enrollment;
    if (!directory) {
        directory = (enrollment && enrollment.id);
    }
    const commonImgProps: any = {
        alt: 'Identity Licence',
        className: 'img-responsive floatLeft',
        title: 'Identity Licence'
    };

    const onViewDocument = () => {
        setPopUpImage(true);
    };
    const onView = () => OnView && isFunc(OnView) ? OnView(file) : onViewDocument();

    // fullFileName will be like Test.png
    const getSignedAndSecuredURL = async (fullFileName: string) => {
        let file = fullFileName.split(".");
        let fileType = file[file.length - 1].toUpperCase();
        const contentType = (fileType === "PDF") ? ("text/pdf") : ("image/*");
        let queryObj = {
            objectName: fullFileName,
            contentType: contentType,
        };
        const s3url_backpath = await awsActions.getSecureUrl(directory, queryObj, true);
        isDebug() && console.info({s3url_backpath})
        setSecureFilePath(s3url_backpath);
        setFileExt(fileType);
    };

    React.useEffect(() => {
        if (file.name) {
            getSignedAndSecuredURL(file.name).then();
        }
    }, [file.name]);

    return (
            <div className="imgWrap">
                {
                    fileExt === "PDF" ?
                            <img
                                    {...commonImgProps}
                                    style={{maxWidth: 150, maxHeight: 150}}
                                    src={pdfIcon}
                            /> :
                            <img
                                    {...commonImgProps}
                                    src={secureFilePath}
                            />
                }
                <div className="btnfix">
                    <Button color="primary" onClick={onView} variant="contained">
                        View
                    </Button>
                    {
                            onDelete && isFunc(onDelete) &&
                            <Button color="primary" onClick={() => onDelete(file)} variant="contained">
                                Delete
                            </Button>
                    }
                </div>
                {
                        popUpImage &&
                        <PreviewFileDialog
                                fileExt={fileExt}
                                onClose={() => setPopUpImage(false)}
                                popUpImage={popUpImage}
                                secureFilePath={secureFilePath}
                                title={file.viewTitle}
                        />
                }
            </div>
    )
}

export default PreviewFiles